import { Switch } from 'react-router';
import { HashRouter as Router, Route } from 'react-router-dom';
import { SplashPage } from "./pages/splash/SplashPage";
import { ContentPage } from "./pages/content/ContentPage";
import { DataContextProvider } from "./services/DataContext";
import { Footer } from "./components/footer/Footer";

function App() {
  return (
    <DataContextProvider>
      <div className="App">

        <Router>
          <Switch>
            <Route path="/content/:section">
              <ContentPage />
            </Route>
            <Route path="/">
              <SplashPage />
            </Route>
          </Switch>
          <div id="DialogHolder"></div>
          <Footer />
        </Router>
      </div>
    </DataContextProvider>
  );
}

export default App;
